import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '罗森 AI 管理平台',
  jaTitle: 'ローソンAI管理プラットフォーム',
  pwa: true,
  // logo: '/luosen.png',
  iconfontUrl: '',
  siderWidth: 220,
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    header: {
      // colorBgHeader: '#001529',
      // colorHeaderTitle: '#ffffff',
      // colorTextRightActionsItem: '#ffffff',
      heightLayoutHeader: 56,
    },
    sider: {
      colorMenuBackground: '#001529',
      colorTextMenu: '#eee',
      colorTextMenuSelected: '#ffffff',
      colorBgMenuItemSelected: '#1678ff',
      colorTextMenuItemHover: '#ffffff'
    }
  },
};

export default Settings;
